import confetti from 'canvas-confetti';

export function triggerConfetti(options: Partial<confetti.Options> = {}) {
  confetti({
    particleCount: 100,
    spread: 70,
    origin: { x: 0.5, y: 0.5 }, // Center of the screen
    colors: ['#FFD700', '#FFA500', '#FF69B4', '#00FF00', '#4169E1'],
    disableForReducedMotion: true,
    scalar: 1,
    gravity: 0.8,
    ticks: 200,
    startVelocity: 30,
    shapes: ['circle', 'square'],
    ...options
  });
}
